/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2022-06-26 22:24:06
 * @LastEditTime: 2024-05-12 15:48:40
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import Router from 'vue-router'
import IndexRouter from "./router/index.router";//首页

Vue.use(Router)

const router = new Router({
    mode: "hash",
    routes: [
        {
            path: "",
            redirect: "/login",
        }
    ].concat(
       IndexRouter
    )
});

export default router;
